import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

export function LoadingScreen(): JSX.Element {
	return (
		<Stack
			alignItems={'center'}
			sx={{
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				pt: 2,
			}}
		>
			<CircularProgress size={50} />
		</Stack>
	);
}
